import { Avatar, Box, Paper, Typography } from "@mui/material";
import React from "react";
import ReactPlayer from "react-player";
import SpeakerNotesIcon from "@mui/icons-material/SpeakerNotes";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import SchoolIcon from "@mui/icons-material/School";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";

export default function HeaderSingleTeacher({ teacher }) {
  const lang = Cookies.get("i18next") || "en";
  const { t } = useTranslation();
  return (
    <Paper sx={{ padding: { xs: "16px", md: "24px" }, marginY: "30px" }}>
      <ReactPlayer url={teacher?.videoLink} width="100%" />

      {teacher?.F2FSessionStd?.discount > 0 && (
        <Box sx={{ backgroundColor: "#e2efff", mb: 2, p: 0.5 }}>
          <Typography textAlign="center">
            <img src="../gift.svg" alt="" style={{ verticalAlign: "middle", marginRight: "8px" }} />
            {t("discount_precent")} {teacher?.F2FSessionStd?.discount}%
          </Typography>
        </Box>
      )}

      <Box
        sx={{
          marginTop: "30px",
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          gap: 3,
          alignItems: { xs: "center", sm: "flex-start" },
        }}
      >
        <Avatar
          src={`${process.env.REACT_APP_API_KEY}images/${teacher?.image}`}
          sx={{
            width: { xs: 100, sm: 120, md: 141 },
            height: { xs: 100, sm: 120, md: 141 },
          }}
        />

        <Box sx={{ width: "100%" }}>
          <Typography
            sx={{ fontSize: "20px", marginBottom: "8px", fontWeight: "700", textAlign: { xs: "center", sm: "left" } }}
          >
            {teacher?.firstName + " " + teacher?.lastName}
          </Typography>

          {/* Languages Spoken */}
          <Box sx={infoBoxStyle}>
            <SpeakerNotesIcon sx={iconStyle} />
            <Typography sx={labelStyle}>{t("speaks")}:</Typography>
            <Typography sx={textStyle}>
              {lang === "ar"
                ? teacher?.LangTeachStds?.map(item => item?.Language?.titleAR + " ")
                : teacher?.LangTeachStds?.map(item => item?.Language?.titleEN + " ")}
            </Typography>
          </Box>

          {/* Certified Teacher */}
          <Box sx={infoBoxStyle}>
            <SpeakerNotesIcon sx={iconStyle} />
            <Typography sx={labelStyle}>{t("certifiedTeacher")}:</Typography>
            <Typography sx={textStyle}>
              {teacher?.experienceYears} {t("yearsofexperience")}
            </Typography>
          </Box>

          {/* Location */}
          <Box sx={infoBoxStyle}>
            <LocationOnIcon sx={iconStyle} />
            <Typography sx={labelStyle}>{t("location")}:</Typography>
            <Typography sx={textStyle}>
              {teacher?.city + " , " + teacher?.country}
            </Typography>
          </Box>

          {/* Subjects */}
          <Box sx={infoBoxStyle}>
            <SchoolIcon sx={iconStyle} />
            <Typography sx={labelStyle}>{t("subjects")}:</Typography>
            <Typography sx={textStyle}>
              {lang === "ar"
                ? teacher?.TeacherSubjects?.map(item => item?.Subject?.titleAR + " ")
                : teacher?.TeacherSubjects?.map(item => item?.Subject?.titleEN + " ")}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Paper>
  );
}

const infoBoxStyle = {
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  gap: "4px",
  marginBottom: "8px"
};

const iconStyle = {
  fontSize: "16px",
  color: "#d5d5d5"
};

const labelStyle = {
  color: "#4f4f51",
  fontSize: "14px",
  fontWeight: "bold"
};

const textStyle = {
  color: "#616161",
  fontSize: "14px"
};
